import { render, staticRenderFns } from "./Noticedetails.vue?vue&type=template&id=dc522588&scoped=true&"
import script from "./Noticedetails.vue?vue&type=script&lang=js&"
export * from "./Noticedetails.vue?vue&type=script&lang=js&"
import style0 from "./Noticedetails.vue?vue&type=style&index=0&id=dc522588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc522588",
  null
  
)

export default component.exports